import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ImageBlockFragment } from '../image-block'
import { JumpToLinksBlockFragment } from '../jump-to-links-block'
import { RichTextBlockFragment } from '../rich-text-block'
import { FaqsBlockFragment } from '../faqs-block'
import { SpacerBlockFragment } from '../spacer-block'

export const AccordianBlockFragment: BlockFragment = {
  name: 'accordian',
  fragment: gql`
    fragment accordian on Accordian {
      id
      blockName
      blockType
      entries {
        id
        title
        content {
          ${FaqsBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
        }
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
    `,
  partialFragment: `
    ...on Accordian {
      id
      blockName
      blockType
      entries {
        id
        title
        content {
          ${FaqsBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
        }
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
    `,
}

export const AccordianBlockType = 'accordian'

export interface AccordianBlock extends BaseBlock {
  blockType: typeof AccordianBlockType
  entries: {
    id: string
    title: string
    content: BaseBlock[]
  }[]
}
